import useNavigateWithSearch from '../../../../../../hooks/useNavigateWithSearch';
import BrokenHeart from '../../../../images/broken-heart.svg';
import { formatTransactionDate } from '../../../../utils/dates';

import useScrollToTop from '../../../../utils/hooks/useScrollToTop';

import { BUTTON_SIZE, BUTTON_TYPE, Button } from '../../../../global/Button';
import { ROUTE_MEMBERSHIP } from '../../../../config/routes';

import './FinalStep.scss';

const FinalStep = ({ membershipSubscriptionData }) => {
  useScrollToTop();
  const navigateWithSearch = useNavigateWithSearch();

  return (
    <div className="FinalStep">
      <div className="FinalStep__container">
        <div className="FinalStep__container--content">
          <div className="FinalStep__container--content--header">
            <div className="FinalStep__container--content--header-icon">
              <img src={BrokenHeart} alt="Broken-Heart" />
            </div>
            <div className="FinalStep__container--content--header-title">
              We’re sad to see you go.
            </div>
          </div>
          <div className="FinalStep__container--content-description">
            {`Your membership will end on ${formatTransactionDate(membershipSubscriptionData.currentPeriodEnd)}, and your payment method will not be charged again.`}
          </div>
        </div>
        <div className="FinalStep__container--footer">
          <Button
            type={BUTTON_TYPE.QUATERNARY}
            size={BUTTON_SIZE.LARGE}
            onClick={() => navigateWithSearch(ROUTE_MEMBERSHIP)}
          >
            Done
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FinalStep;
